/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { OasisDashboardViewModel } from './OasisDashboardViewModel'; 

export function getOasisDashboardOptions(onSuccess?: (result: OasisDashboardViewModel) => void) {
	return queryOptions({
		queryKey: ['oasis-dashboard'],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/oasis/queries/getoasisdashboard/';
			const resp = await axios.get<OasisDashboardViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: true
	});
}